









































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Department } from '@/models/admin/department';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getDepartmentListHeaders } from '@/views/admin/department/department';
import {departmentService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Stores: () => import('@/components/common/store.select.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class DepartmentListPage extends Base {
  public headers: VHeaders[] = getDepartmentListHeaders(this);
  public pagedDepartments: Department[] = [];
  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public storeId: number;
  public actions: any[] = [];
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('departments.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    onAction: (): void => {
      this.deleteDepartment();
    },
  };
  public departmentToDelete: Department = {
    id: '',
    name: '',
    storeId: 0,
    description: '',
  };
  public preventPaginationCall: boolean = false;
  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: this.$t(
          'departments.departmentGridHeaders.gridAction.edit'
        ) as string,
        action: (model: Department, storeId: string) => {
          return {
            name: 'admin.departments.managers',
            params: { storeId: this.storeId, id: model.name },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'departments.departmentGridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        action: (model: Department, storeId: string) => {
          this.confirmDelete(model);
        },
      },
    ];
  }

  public created() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = this.userSession.storeId;
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addDepartment') {
      this.$router.push({
        name: 'admin.departments.add',
        params: { storeId: this.storeId.toString() },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('departments.btnAddDepartment'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('departments.btnAddDepartment'),
      click: 'addDepartment',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'departments');

    if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
      this.getDepartments(this.storeId);
    }
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
  }

  public async getDepartments(storeId: number): Promise<void> {
    try {
      this.loading = true;
      const departments = await departmentService.getDepartmentsAsync(
        storeId,
        this.pagination
      );
      this.pagedDepartments = departments.results;
      this.pagination.totalItems = departments.total;
    } finally {
      this.loading = false;
    }
  }
  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public confirmDelete(item: Department): void {
    this.deleteDialog.model = true;
    this.departmentToDelete = item;
  }

  public async deleteDepartment(): Promise<void> {
    try {
      await departmentService.deleteAsync(
        this.departmentToDelete.name,
        this.storeId
      );
      this.preventPaginationCall = true;
      this.showAlert(true, this.$t('departments.alertDeleteDepartment'));
      this.getDepartments(this.storeId);
    } catch (e) {
      console.log(e);
    } finally {
      this.deleteDialog.model = false;
    }
  }

  public updateStore(storeId: number): void {
    this.storeId = storeId;
    this.getDepartments(this.storeId);
  }
}
